// recaptcha site keys

export const RECAPTCHA_KEYS = {
  RECAPTHATESTKEY: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
  RECAPTCHAREGISTERSITEKEY: '6LfrpXEUAAAAAPBKa1tVgQ5ynOq-Gt_hqHpx2awO',
  RECAPTCHALOGINSITEKEY: '6LfPlOsUAAAAAIALEFUM1022nNwsyWjpATeuYMdi',
  RECAPTCHAIDEKEY: '6LfPlOsUAAAAAIALEFUM1022nNwsyWjpATeuYMdi'
}
